import React from "react";
import { Monitor } from "lucide-react";
import { HERO_IMAGE_URL } from "../../lib/heroImage";

/**
 * Conversion-focused hero for /online-courses.
 */
export default function OnlineCoursesHero({ onFindTeacher, onBookConsultation, teacherPhotos = [] }) {
  const photos = teacherPhotos.filter(Boolean).slice(0, 4);
  const usePhotoStrip = photos.length >= 2;

  return (
    <section className="relative min-h-[min(88vh,640px)] bg-gray-900 overflow-hidden">
      <div className="absolute inset-0">
        {usePhotoStrip ? (
          <div className="grid h-full w-full grid-cols-2 md:grid-cols-4">
            {photos.map((src, index) => (
              <div key={`${src}-${index}`} className="relative overflow-hidden">
                <img
                  src={src}
                  alt=""
                  className="h-full w-full object-cover object-top opacity-55"
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  fetchPriority={index === 0 ? "high" : "auto"}
                />
              </div>
            ))}
          </div>
        ) : (
          <img
            src={photos[0] || HERO_IMAGE_URL}
            alt=""
            className="h-full w-full object-cover opacity-50"
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/55 via-gray-900/70 to-gray-900" />
      </div>

      <div className="relative container mx-auto px-4 flex min-h-[min(88vh,640px)] flex-col justify-center py-16 md:py-20">
        <div className="max-w-2xl animate-[fadeInUp_0.7s_ease-out]">
          <span className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-500/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-emerald-100 backdrop-blur-md">
            <Monitor size={14} /> Online · Personalized · Real teachers
          </span>
          <h1 className="mt-5 text-4xl font-black leading-tight tracking-tight text-white md:text-5xl lg:text-[3.25rem]">
            Find the Right Online Yoga Teacher for You
          </h1>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-gray-200">
            Learn yoga from experienced teachers through personalized 1-to-1 and live online sessions.
            Class times are shown in your timezone, so you can pick a slot that actually fits your day.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
              type="button"
              onClick={onFindTeacher}
              className="inline-flex items-center justify-center rounded-lg bg-emerald-600 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-emerald-900/30 transition-colors hover:bg-emerald-700"
            >
              Find My Yoga Teacher
            </button>
            <button
              type="button"
              onClick={onBookConsultation}
              className="inline-flex items-center justify-center rounded-lg bg-white px-6 py-3.5 text-sm font-semibold text-emerald-800 shadow-lg shadow-black/10 transition-colors hover:bg-emerald-50"
            >
              Book a Free 15-Minute Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
